import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/AllTalentAgencyCompany.graphql';
import { Query, QueryallTalentAgencyCompanyArgs } from '../../__generated__/globalTypes';

export const useAllTalentAgencyCompanyQuery = (options?: QueryHookOptions<Query, QueryallTalentAgencyCompanyArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryallTalentAgencyCompanyArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAllTalentAgencyCompanyLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryallTalentAgencyCompanyArgs>
): QueryResult<Query, QueryallTalentAgencyCompanyArgs> & {
  getAllTalentAgencyCompany: LazyQueryExecFunction<Query, QueryallTalentAgencyCompanyArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getAllTalentAgencyCompany, result] = useLazyQuery<Query, QueryallTalentAgencyCompanyArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getAllTalentAgencyCompany, ...result };
};

export const useAllTalentAgencyCompanyPromiseQuery = () => {
  const client = useApolloClient();

  const getAllTalentAgencyCompany = useCallback(
    (options?: Omit<QueryOptions<QueryallTalentAgencyCompanyArgs, Query>, 'query'>) =>
      client.query<Query, QueryallTalentAgencyCompanyArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getAllTalentAgencyCompany };
};
// Suspense Query Hooks
export const useAllTalentAgencyCompanySuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryallTalentAgencyCompanyArgs>
) => {
  const result = useSuspenseQuery<Query, QueryallTalentAgencyCompanyArgs>(QUERY, {
    ...options
  });

  return result;
};
